import type { NormalizedProduct, SearchFilters, SupplierId } from '../types'
import { ALL_SUPPLIER_IDS } from '../connectors/types'

export function createDefaultFilters(): SearchFilters {
  return {
    suppliers: [...ALL_SUPPLIER_IDS],
    brands: [],
    minPrice: undefined,
    maxPrice: undefined,
    inStockOnly: false,
    maxDeliveryDays: undefined,
  }
}

export function applyFilters(
  products: NormalizedProduct[],
  filters: SearchFilters,
): NormalizedProduct[] {
  return products.filter((p) => {
    if (filters.suppliers.length > 0 && !filters.suppliers.includes(p.supplier as SupplierId)) {
      return false
    }
    if (filters.brands.length > 0 && !filters.brands.includes(p.brand)) {
      return false
    }
    if (filters.minPrice != null && p.pixPrice < filters.minPrice) return false
    if (filters.maxPrice != null && p.pixPrice > filters.maxPrice) return false
    if (filters.inStockOnly && p.stock <= 0) return false
    if (filters.maxDeliveryDays != null && p.estimatedDelivery > filters.maxDeliveryDays) {
      return false
    }
    return true
  })
}
